<template>
  <div class="Vehicle-Image">
    <img :src="vehicleTrailer" class="Pointer Design-Class" />
    <v-progress-linear
      :value="data"
      fixed
      color="primary lighten-5"
      class="Progress-Class"
    >
      <template v-slot:default="{ value }">
        <strong>{{ value }}%</strong>
      </template>
    </v-progress-linear>
  </div>
</template>

<script>
import { vehicleTrailer } from "@/assets/map/mapIcons.js";

export default {
  props: {
    data: {
      required: true,
    },
  },
  data() {
    return {
      vehicleTrailer,
    };
  },
};
</script>


<style >
.Vehicle-Image {
  max-width: 100%;
  position: relative;
  height: 100%;
}
.Design-Class {
  /* position: absolute; */
  width: 100%;
  height: 93%;
}
.Progress-Class {
  position: absolute;
  top: 0;
  left: 0;
  height: calc(100% - 45%) !important;
  width: 81%;
  border: 3px solid rgba(128, 128, 128, 0.315);
}
.v-progress-linear__determinate {
  height: 100%;
}
</style>